import DependencyInjector from '@wittignl/js-core/DependencyInjector'

export default new DependencyInjector();
